// Canonical public site URL. Single source of truth - do not redefine per page.
export const SITE_URL = 'https://cphsecuritywait.dk';
